import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=4ecaa88a&scoped=true&"
import script from "./SimpleLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleLayout.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLayout.vue?vue&type=style&index=0&id=4ecaa88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecaa88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecaa88a')) {
      api.createRecord('4ecaa88a', component.options)
    } else {
      api.reload('4ecaa88a', component.options)
    }
    module.hot.accept("./SimpleLayout.vue?vue&type=template&id=4ecaa88a&scoped=true&", function () {
      api.rerender('4ecaa88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/SimpleLayout.vue"
export default component.exports